export default __webpack_public_path__ + "027b53275a2c3006a93e340f22f9fab7.jpg";